export const filterByList: Array<string> = [
  'All Products',
  'Courseware',
  'eBooks',
];
